var $aea1cb4c7ec97e1c$exports = {};
$aea1cb4c7ec97e1c$exports = {
  "removeButtonLabel": "Entfernen",
  "removeDescription": "Auf \u201EL\xF6schen\u201C dr\xFCcken, um das Tag zu entfernen."
};
export { $aea1cb4c7ec97e1c$exports as default };